import { QueryFilter } from "src/app/shared/models/query-filter.model";

export class OutingPermissionUsersQueryFilter extends QueryFilter{
    public userId: string;
    public outingId: string;

}